export const CARD_TEMPLATES = [
  {
    id: "hero",
    label: "Hero Banner",
    previewText: "Big Headline + Button",
    componentType: "heroCard",
     responsive: {
  desktop: { columns: 2 },
  tablet: { columns: 2 },
  mobile: { columns: 1 }},
    elements: [
      { type: "header", content: "🚀 Hero Title", styleRole: "heading" ,styles: { default: {}, theme: {}, custom: {} }},
      { type: "para", content: "A subtitle about your product.", styleRole: "body",styles: { default: {}, theme: {}, custom: {} } },
      { type: "btn", content: "Get Started", styleRole: "button",styles: { default: {}, theme: {}, custom: {} } },
    ],
    
  },
  {
    id: "feature",
    label: "Feature Block",
    previewText: "Icon + Title + Text",
    componentType: "featureCard",
     responsive: {
  desktop: { columns: 3 },
  tablet: { columns: 2 },
  mobile: { columns: 1 }},
    elements: [
      { type: "icon", content: "🔥" ,styles: { default: {}, theme: {}, custom: {} }},
      { type: "header", content: "Feature Title",styles: { default: {}, theme: {}, custom: {} } },
      { type: "para", content: "Short description text here." ,styles: { default: {}, theme: {}, custom: {} }},
    ],styles: { default: {}, theme: {}, custom: {} }
  },
  {
    id: "cta",
    label: "Call To Action",
    previewText: "Text + Button",
    componentType: "ctaCard",
     responsive: {
  desktop: { columns: 3 },
  tablet: { columns: 2 },
  mobile: { columns: 1 }},
    elements: [
      { type: "header", content: "Join Now!",styles: { default: {}, theme: {}, custom: {} } },
      { type: "btn", content: "Sign Up", styleRole: "button",styles: { default: {}, theme: {}, custom: {} } },
    ],styles: { default: {}, theme: {}, custom: {} }
  },
];
